// UI visibility only; the server also checks access to each vacancy.
export function canAccessCandidatePipeline(
  user: { id: number; role: string } | null | undefined
): boolean {
  return Boolean(
    user &&
    [
      "owner",
      "co_owner",
      "tech_admin",
      "sales_manager",
      "coordinator",
      "recruiter",
    ].includes(user.role)
  );
}
